import * as React from 'react';
import { useDrawingArea, useXScale } from '@mui/x-charts';
import { useSunData } from '../hooks/sun';

function VerticalRectangle({ xStart, xEnd }) {
  const { top, height } = useDrawingArea();
  const xScale = useXScale();

  const rectX = xScale(xStart);
  const rectWidth = xScale(xEnd) - xScale(xStart);

  return (
    <rect
      x={rectX}
      y={top}
      width={rectWidth}
      height={height}
      fill="#2e3a75"
      opacity={0.06}
    />
  );
}

export default function NightOverlay({ times }) {
  const sun = useSunData();

  if (!(sun.isLoading || sun.isError)) {
    const sunrise = sun.sunrise;
    const sunset = sun.sunset;

    const dateStrings = Array.from(
      new Set(times.map((time) => time.toDateString()))
    );
    const dates = dateStrings.map((dateString) => new Date(dateString));
    const nightExtents = dates.map((date) => ({
      end: new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        sunrise.getHours() - 8,
        sunrise.getMinutes()
      ),
      start: new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        sunset.getHours() - 8,
        sunset.getMinutes()
      ),
    }));

    return nightExtents.map((extent) => (
      <VerticalRectangle
        key={extent.start}
        xStart={extent['start']}
        xEnd={extent['end']}
      />
    ));
  }
}
